import React from 'react';
import './HeaderLogo.scss';

export const HeaderLogo = ({
  logo,
  to,
  onClick,
}: {
  logo: string;
  to: string;
  onClick?: () => void;
}) => {
  return (
    <button onClick={onClick} className="HeaderLogo">
      <img className="HeaderLogo__image" src={logo} alt="logo" />
    </button>
  );
};
